var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomModebarOpenCloseButtonCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 49,
    viewBox: "0 0 24 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H16C20.1421 1 23.5 4.35786 23.5 8.5V40.5C23.5 44.6421 20.1421 48 16 48H0.5V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H16C20.1421 1 23.5 4.35786 23.5 8.5V40.5C23.5 44.6421 20.1421 48 16 48H0.5V1Z",
    stroke: "#EAECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.5L12 24.5L7 29.5M13 19.5L18 24.5L13 29.5",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModebarOpenCloseButtonCollapsed);
export default __webpack_public_path__ + "static/media/custom-modebar-open-close-button-collapsed.d5cd7fda18f1abef45209acb2078d021.svg";
export { ForwardRef as ReactComponent };